package at.apa.statistictracker.db

import at.apa.statistictracker.db.common.newInstance
import at.apa.statistictracker.db.common.schema
import com.squareup.sqldelight.Transacter
import com.squareup.sqldelight.db.SqlDriver

public interface StatisticTrackerDb : Transacter {
  public val statisticPayloadQueries: StatisticPayloadQueries

  public val userPropertyQueries: UserPropertyQueries

  public companion object {
    public val Schema: SqlDriver.Schema
      get() = StatisticTrackerDb::class.schema

    public operator fun invoke(driver: SqlDriver,
        statisticPayloadTableAdapter: StatisticPayloadTable.Adapter): StatisticTrackerDb =
        StatisticTrackerDb::class.newInstance(driver, statisticPayloadTableAdapter)
  }
}
